const threeMinutesInMilliSeconds = 3 * 60 * 1000;
const twentyMinutesInMilliSeconds = 20 * 60 * 1000;

export const CACHE_AND_STALE_TIME = {
  staleTime: threeMinutesInMilliSeconds,
  cacheTime: twentyMinutesInMilliSeconds,
  refetchOnWindowFocus: false,
} as const;

export const NULL_CACHE_AND_STALE_TIME = {
  staleTime: 0,
  cacheTime: 0,
  refetchOnWindowFocus: false,
} as const;

//use this for data that is unlikely to get mutated
export const INFINITE_CACHE_AND_STALE_TIME = {
  staleTime: Infinity,
  cacheTime: Infinity,
  refetchOnWindowFocus: false,
} as const;

export const PUBLIC_URLS = {
  SPARK_WEBSITE: 'https://sparkup.ai/',
} as const;

export const UNIQUE_SELECTOR_ID = {
  STATUSBAR_QUEUE_PROGRESS: 'status-bar-queue-progress',
  LAYOUT_HEADER: 'spark-layout-header',
  SPARK_RUN_KNOWLEDGE_CONTAINER: 'spark-run-knowledge-container',
  SPARK_RUN_FORM_CONTAINER: 'spark-run-form-container',
  SPARK_RUN_CARD_CONTAINER: 'spark-run-card-container',
  SPARK_OVERLAY: 'spark-overlay',
  SPARK_OVERLAY_CLASS: 'spark-overlay-class_selector',
  SPARK_SCROLLABLE_CHILD_CONTAINER_CLASS:
    'spark-spark-scrollable-child-container',
} as const;

export const MAX_FILE_SIZE = 15728640; // 15MB
